import React, { useState, useContext, useEffect } from "react";
import Pro from "../../assets/images/pro.png";
import location from "../../assets/images/location.png";
import clock from "../../assets/images/clock.png";
import ClinicProvider from "../../Provider/ClinicProvider";
import SearchProvider from "../../Provider/SearchProvider";
import { useParams } from "react-router-dom";
import { Breadcrumb } from "antd";
import DoctorCard from "../../UI/DoctorCard/DoctorCard";
import Appointment from "./Appointment";
import TimerPopup from "../../UI/TimerPopup/TimerPopup";
import Slider from "../../UI/Swiper/Slider";
import Spinder from "../../UI/Spiner/Spinder";
import Meta from "../../Meta/Meta";

const ClinicInstruction = () => {
  const { slug } = useParams();
  // console.log("slug", slug);
  // const [open, setOpen] = useState(false);

  const [openTimer, setOpenTimer] = useState(false);
  const { clinicData, getClinicData, ClinicLoader } =
    useContext(ClinicProvider);
  const { addAppointmentPopup, setAddAppointmentPopup } =
    useContext(SearchProvider);
  useEffect(() => {
    if (slug) {
      getClinicData(slug); // Pass the slug as an argument to getClinicData
    }
  }, [slug]); // Run when slug changes

  // console.log("clinicData", clinicData); // Check if the data has been fetched
  // console.log(clinicData?.[0]?.before_after_image);
  // console.log("getClinicData", getClinicData); // Check if the function is available
  return (
    <>
      <Meta slug={slug} />
      <section className="my-[5vh]">
        {ClinicLoader ? (
          <Spinder />
        ) : (
          <>
            <div className="container">
              <Breadcrumb
                separator="/"
                items={[
                  {
                    title: "Home",
                    href: "/",
                  },
                  {
                    title: "Clinic",
                    href: "/app/clinic",
                  },
                  {
                    title: `${clinicData?.[0]?.name}`,
                  },
                ]}
              />
              <div className="flex flex-col md:flex-row justify-between gap-0 md:gap-[40px] ">
                <div className="w-full md:w-[calc(20%-20px)] bg-blue-200">
                  <div className="hidden md:block">
                    {clinicData?.[0]?.logo_image ? (
                      <img
                        src={`${process.env.REACT_APP_BASE}${clinicData[0].logo_image}`}
                        alt="Clinic Logo Image"
                        className="w-full h-auto"
                      />
                    ) : (
                      <img
                        src={Pro}
                        alt="Placeholder Clinic Logo Image"
                        className="w-full h-auto"
                      />
                    )}
                  </div>
                </div>
                <div className="w-full md:w-[calc(50%-20px)] bg-green-200">
                  <h1 className="font-primary text-primary font-bold text-[2.2rem] mt-4">
                    {clinicData?.[0]?.name && <span>{clinicData[0].name}</span>}
                  </h1>
                  <div className="block md:hidden my-[15px] ">
                    {clinicData?.[0]?.clinic_image?.length > 0 ? (
                      <img
                        src={`${process.env.REACT_APP_BASE}${clinicData[0].clinic_image[0]}`}
                        alt="First Clinic Image"
                        className="w-full h-auto"
                      />
                    ) : (
                      <img
                        src={Pro}
                        alt="Placeholder Clinic Image"
                        className="w-full h-auto"
                      />
                    )}
                  </div>
                  <p className="font-primary text-lightgray font-thin text-[14px] mt-[1rem] ">
                    {clinicData?.[0]?.short_description && (
                      <span>{clinicData[0].short_description}</span>
                    )}
                  </p>
                  <div className="flex justify-between items-center  mt-[1rem] flex-col sm:flex-row gap-5 sm:gap-[10vw]">
                    <div className="flex gap-4 items-center">
                      <img src={location} className="w-[20px] h-auto" />
                      <div className="font-primary text-lightgray font-normal text-[1.2rem]">
                        <div className="font-primary text-lightgray font-thin text-[14px]">
                          {clinicData?.[0]?.address_line1 && (
                            <span>{clinicData[0].address_line1} </span>
                          )}
                          {clinicData?.[0]?.address_line2 && (
                            <span>{clinicData[0].address_line2}, </span>
                          )}
                          {clinicData?.[0]?.secretariats_data?.name},{" "}
                          {clinicData?.[0]?.district_data?.name},{" "}
                          {clinicData?.[0]?.province_data?.name} -
                          {clinicData?.[0]?.pin_code}
                        </div>
                      </div>
                    </div>
                    <div className="w-[50%]  mt-4">
                      <div
                        className="flex max-w-[150px]  justify-center border border-primary font-medium  mx-auto cursor-pointer text-primary px-8 py-4 rounded-lg text-[14px] hover:bg-primary hover:text-white transition-all duration-300 ease-in-out text-nowrap"
                        onClick={() => setOpenTimer(true)}
                      >
                        Clinic Timing
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-[calc(30%-20px)] bg-red-200 flex justify-center items-center mt-[20px] md:mt-0">
                  <div
                    className="max-w-[200px] bg-primary font-medium  mx-auto cursor-pointer text-center text-white px-8 py-4 rounded-lg text-[14px] text-nowrap hover:bg-milkgreen transition-all duration-300 ease-in-out"
                    onClick={() => setAddAppointmentPopup(true)}
                  >
                    For Appointment
                  </div>
                </div>
              </div>
              <div className="w-full h-[1px] bg-lightgray mt-[20px] opacity-5"></div>
              <h3 className="font-secondary text-black font-medium text-[2.2rem] mt-[20px]">
                Doctors
              </h3>
              {clinicData?.[0]?.doctor_list?.map((item, index) => (
                <DoctorCard key={index} doctorData={item} />
              ))}
              {clinicData?.[0]?.clinic_image?.length > 0 && (
                <div className="my-[10vh]">
                  <h3 className="font-secondary font-medium text-[2rem] mb-[20px]">
                    Gallery
                  </h3>
                  <Slider images={clinicData?.[0]?.clinic_image} />
                </div>
              )}

              {clinicData?.[0]?.before_after_image?.length > 0 && (
                <div className="my-[10vh]">
                  <h3 className="font-secondary font-medium text-[2rem] mb-[20px]">
                    Before & After
                  </h3>
                  <Slider images={clinicData?.[0]?.before_after_image} />
                </div>
              )}

              <div className="my-[10vh]">
                <h3 className="font-secondary font-bold text-[20px]">
                  Disclaimer
                </h3>
                <p className="font-primary font-thin text-[1.6rem] mt-8 text-[#666363] text-justify md:text-left">
                  {clinicData?.[0]?.long_description}
                </p>
              </div>
            </div>
            <Appointment />
            <TimerPopup
              open={openTimer}
              setOpen={setOpenTimer}
              clinicTiming={clinicData?.[0]?.clinic_timing}
            />
          </>
        )}
      </section>
    </>
  );
};

export default ClinicInstruction;
